import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { BlackBgRoundButton } from 'components/button';
import { useForm } from 'react-hook-form';
import { redirectToHome, redirectToOld } from '__utils/common-utils';
import { COLOR } from 'constants/colors';
import { ClickableSpan } from 'views/common-styled-components';
import { propsToJS } from '__utils/immutable-to-js';
import { useSelector } from 'react-redux';
import { getEventName, Mixpanel } from '__utils/mixpanel';
import { useMediaQuery } from 'react-responsive';
import useFlashToggler from 'hooks/use-flash-toggler';
import { CommonStyledComponentProps } from '__utils/type';
import SmallPopup from 'components/popup/small-popup';
import { CalculatorAdvisor, EmailInputBox, MobileInputBox, NameInputBox } from 'components/common-components';
import LargePopup from 'components/popup/large-popup';
import logo1 from "images/logo1.png";
import calculatorLeadSuccess from "images/calulator_lead_success.svg";
import { getDefaultHeaders, post } from '__utils/ajax-wrapper';
import resolveURLParams from '__utils/url-params-resolver';
import { ENDPOINTS } from 'constants/endpoints';
import { AjaxResponse, AjaxError } from 'rxjs/ajax';
import InvestmentCalculatorSelector from './investment-calculator.selector';
import GreaterIcon from 'assets/icons/greater-than-icon';
import { LayoutContext } from 'components/app-routes';

const CustomerOuterCont = styled.div<CommonStyledComponentProps>`
    .interested-title{
        margin-bottom: 16px;
        h3{
            font-size: ${(props: any) => props.isMobile ? '18px' : '20px'}; 
            margin-bottom: 14px;
        }
        p{
            font-size: ${(props: any) => props.isMobile ? '14px' : '16px'}; 
        }
    }
    .greyLabel{
        color: #4D5556;
    }
`;

const OuterContainer = styled.div<CommonStyledComponentProps>`
    background-color: ${COLOR.WHITE};
    padding: 48px 16px;
    height: ${(props: CommonStyledComponentProps) => props.isMobile ? `calc(100vh - 58px)` : `auto`};
    text-align: center;
    .vertical{
        margin: 0;
    }
    img{
        margin-bottom: 10px;
    }
    h3{
        font-weight: 500;
        font-size: 18px;
    }
    h4{
        font-weight: 500;
        font-size: 16px;
    }
    p{
        font-weight: 500;
        font-size: 14px;
        color: ${COLOR.GREY3};
    }
    .yellow-rectangle{
        background: linear-gradient(98.15deg, #FFF6E0 -2.8%, #FFEABA 106.9%);
        padding: 20px 32px;
        p{
            font-weight: 400 !important;
            font-size: 12px !important;
        }
        border-radius: 8px;
        margin-bottom: 30px;
    }
    .homeLink{
        text-decoration: underline;
        color: #000;
        font-weight: 500;
    }

`;

const ButtonContainer = styled.div`
    margin-top: -20px;
    text-align: center;
    button{
        width: 200px;
    }
`
const InterestedUserPopup: React.FC = () => {

    const isMobile = useMediaQuery({ maxWidth: 767 });
    const flash = useFlashToggler();
    const [showInterestedPopup, setShowInterestedPopup] = useState<boolean>(false);
    const [showLeadSuccessMessage, setShowLeadSuccessMessage] = useState<boolean>(false);
    const { layoutProps, SetLayoutProps } = React.useContext(LayoutContext);

    const { handleSubmit, control, formState } = useForm({
        mode: 'onChange', defaultValues: {
            clientName: '',
            primaryMobile: '',
            primaryEmail: '',

        }
    });
    const { errors } = formState;
    const { customerFromSharedLinkDetails } = propsToJS(useSelector(InvestmentCalculatorSelector));

    useEffect(() => {
        SetLayoutProps({
            showGlobalFooter: true
        })
    }, [])


    const onCalculatorleadSubmit = (data: any) => {
        Mixpanel.track(getEventName("IamInterestedButton", "clicked"));
        post(resolveURLParams(ENDPOINTS.POST_SAVE_INTERESTED_CUSTOMER_DETAILS, {}, {}), { userName: data?.clientName, mobile: data?.clientMobile, emailId: data?.clientEmail, agentCode: customerFromSharedLinkDetails?.sharedByAgent, sendNotification: true }, getDefaultHeaders(), true)
            .subscribe((response: AjaxResponse | AjaxError) => {
                if (response.response?.data) {
                    setShowInterestedPopup(false);
                    setShowLeadSuccessMessage(true);
                    Mixpanel.track(getEventName("IamInterestedLead", "completed"));
                }
                else if (response.response?.meta?.error) flash.error(response.response?.meta?.error);
                else flash.error("Something went wrong. Please try again later");

            }, (error: AjaxError) => {
                flash.error("Something went wrong. Please try again later")
            });
    }

    const ShareCustomerContent = () => {
        return (<CustomerOuterCont isMobile={isMobile}>
            <div className='interested-title'>
                <h3>Enter your Details</h3>
                <p>Your advisor will get in touch with you soon</p>
            </div>
            <form name="createLeadForm" onSubmit={handleSubmit(onCalculatorleadSubmit)} noValidate>
                <NameInputBox
                    name="clientName"
                    id="clientName"
                    placeholder='Enter Your Name'
                    control={control}
                    errors={errors}
                    rules={{
                        required: 'Please enter your full name'
                    }}
                    inputLabel={<p className="greyLabel">Full Name</p>}
                />
                <MobileInputBox
                    name="clientMobile"
                    id="clientMobile"
                    placeholder='Enter Your Number'
                    control={control}
                    errors={errors}
                    rules={{
                        required: 'Please enter your mobile number'
                    }}
                    inputLabel={<p className="greyLabel">Phone Number</p>}
                />
                <EmailInputBox
                    name="clientEmail"
                    id="clientEmail"
                    placeholder='Enter Your Email ID'
                    control={control}
                    errors={errors}
                    rules={{
                        required: 'Please enter your email id'
                    }}
                    inputLabel={<p className="greyLabel">Email ID</p>}
                />
                <div className='button-center'>
                    <BlackBgRoundButton type="submit" disabled={!formState.isValid}>Save & Continue &nbsp;<GreaterIcon color={COLOR.WHITE} /></BlackBgRoundButton>
                </div>
            </form>

        </CustomerOuterCont >);
    }
    const exploreMore = () => {

        Mixpanel.track(getEventName("exploreMoreFunds", "clicked", "IamInterestedSuccessPopup"));
        setShowLeadSuccessMessage(false);
        redirectToOld('best-performing-funds');
    }

    return (
        <>
            {
                showInterestedPopup &&
                <SmallPopup content={ShareCustomerContent()} closable={true} onClose={() => setShowInterestedPopup(false)}> </SmallPopup>
            }
            {
                showLeadSuccessMessage &&
                <LargePopup
                    onClose={() => setShowLeadSuccessMessage(false)}
                    headerContent={
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div onClick={() => redirectToHome()}><img alt="Turtlemint Money - Invest in best performing funds by consulting experts for free" src={logo1} style={{ height: '35px' }} /></div>
                            <CalculatorAdvisor />
                        </div>}
                >
                    <OuterContainer isMobile={isMobile}>
                        <div className={isMobile ? 'vertical' : ''}>
                            <div className='yellow-rectangle'>
                                <img src={calculatorLeadSuccess} alt="success" />
                                <h4>Thank you for showing interest</h4>
                                <p>Your advisor will contact you shortly to assist you.</p>
                            </div>
                            <h3>Looking for top performing funds?</h3>
                            <p>Find the collection of mutual funds carefully selected based on thorough research and market analysis.</p>
                            <div className='button-center mt30 mb30'>
                                <BlackBgRoundButton onClick={exploreMore}>Explore more funds &nbsp; <GreaterIcon color={COLOR.WHITE} /></BlackBgRoundButton>
                            </div>
                            <ClickableSpan className="homeLink" onClick={() => redirectToHome()}>Go to homepage</ClickableSpan>
                        </div>
                    </OuterContainer>
                </LargePopup>
            }

            <ButtonContainer>
                <BlackBgRoundButton onClick={() => setShowInterestedPopup(true)}>I’m Interested</BlackBgRoundButton>
            </ButtonContainer>

        </>
    );
}

export default InterestedUserPopup;